import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormFieldWrapperComponent } from '../form-field-wrapper/form-field-wrapper.component';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { Control } from 'leaflet';

import { ColorsetStore } from '../../../stores/colorset/colorset.state';
import { Colorset } from '../../../models/colorset';
import { Scale } from '../../../models/scale';

@Component({
  selector: 'app-legend-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormFieldWrapperComponent,
    InputTextModule,
  ],
  templateUrl: './legend-form.component.html',
  styleUrl: './legend-form.component.scss',
})
export class LegendFormComponent implements OnChanges {
  @Input({ required: true }) legendFormArray!: FormArray;
  @Input({ required: true }) colorsetId!: string;
  @Input({ required: true }) legendData!: Scale[];
  @Input() invert = false;
  @Input() legendMode!: string;

  //legendFormArray: FormArray = [];
  readonly colorsetStore = inject(ColorsetStore);

  constructor(private fb: FormBuilder) {}

  selectedColorset?: Colorset;

  /**
   * Retrieves a specific FormGroup from the legendFormArray at the given index.
   *
   * @param {number} index - The index of the FormGroup to retrieve.
   * @return {FormGroup} The FormGroup at the specified index within legendFormArray.
   */
  getLegendGroup(index: number): FormGroup {
    return this.legendFormArray.at(index) as FormGroup;
  }

  /**
   * Lifecycle hook called when any data-bound property of a directive changes.
   * This method is triggered whenever the Angular detects changes to the @Input properties of the component.
   *
   * @param {SimpleChanges} changes - An object encapsulating the changed properties. Each changed property includes the current and previous values.
   * @return {void} This method performs operations based on observed changes and does not return any value.
   */
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes['colorsetId']) {
      // avoid ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => {
        this.setLegendFormArray(this.colorsetId);
      });
    }
  }

  /**
   * Updates the legend form array based on the selected colorset and the provided legend data.
   *
   * @param {string} colorsetId - The identifier for the colorset to retrieve and apply to the legend form array.
   * @return {void} Does not return a value; modifies the legend form array directly.
   */
  private setLegendFormArray(colorsetId: string): void {
    const legend = this.legendData || this.legendFormArray.value;
    this.selectedColorset = this.colorsetStore.getById(colorsetId);

    console.log('setLegendFormArray', legend, this.selectedColorset);
    if (
      legend &&
      this.selectedColorset &&
      this.selectedColorset?.colors.length
    ) {
      this.legendFormArray.clear();
      const colorCount = this.selectedColorset.colors.length || 0;
      if (legend.length <= colorCount) {
        for (let i = 0; i < colorCount; i++) {
          this.addScale(legend[i]);
        }
      } else if (this.legendFormArray.length > colorCount) {
        for (let i = this.legendFormArray.length - 1; i >= colorCount; i--) {
          this.legendFormArray.removeAt(i);
        }
      }
      console.log('this.legendFormArray:', this.legendFormArray);
    }
  }

  /**
   * Adds a scale to the `legendFormArray`. Creates a new form group with the provided or default scale values.
   *
   * @param {Scale} [scale] An optional scale object containing values for 'from', 'to', and 'text'.
   * @return {void} This method does not return any value.
   */
  private addScale(scale?: Scale): void {
    console.log('add scale?');
    const scaleGroup = this.fb.group({
      from: [scale ? scale.from : '', Validators.required],
      to: [scale ? scale.to : '', Validators.required],
      text: [scale ? scale.text : ''],
    });
    this.legendFormArray.push(scaleGroup);
  }
}
